export enum themeNames {
  light = 'LightTheme',
  dark = 'DarkTheme',
}

export interface IThemeState {
  theme: themeNames | string;
}
